export const ADD_NOTIFICATION = 'notify/add-notification';
export const RECEIVE_NOTIFICATIONS = 'notify/receive-notifications';
export const RECEIVE_POPUPS = 'notify/receive-popups';
export const REMOVE_NOTIFICATION = 'notify/remove-notification';
export const REMOVE_POPUP = 'notify/remove-popup';
export const REQUEST_NOTIFICATIONS = 'notify/request-notifications';
export const SET_TOTAL_NO_READ = 'notify/set-total-no-read';